import {Button, Container, createMuiTheme, Typography, CircularProgress} from '@material-ui/core';
import {Accordion, AccordionDetails, AccordionSummary} from '@material-ui/core';
import {green} from '@material-ui/core/colors';
import {ThemeProvider} from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ApplicationEntryRouteConstants from 'ApplicationEntry/ApplicationEntryRouteConstants';
import AdditionalPropertiesSection from 'ApplicationEntry/components/WorkFlow/AdditionalProperties/AdditionalProperties';
import ApplicantDemographicsSection from 'ApplicationEntry/components/WorkFlow/ApplicantDemographicsSection';
import AWDStatusDashboard from 'ApplicationEntry/components/WorkFlow/AWDStatus/AwdStatusDashboard';
import BillingAgentSection from 'ApplicationEntry/components/WorkFlow/BillingAgent/BillingAgent';
import CaseDetailsSection from 'ApplicationEntry/components/WorkFlow/CaseDetailsSection';
import ContingentBeneficiaryDashboard from 'ApplicationEntry/components/WorkFlow/ContingentBeneficiary/ContingentBeneficiaryDashboard';
import DependentsDashboard from 'ApplicationEntry/components/WorkFlow/Dependents/DependentDashboard';
import HippaTrustees from 'ApplicationEntry/components/WorkFlow/HippaTrustees';
import MessagesSection from 'ApplicationEntry/components/WorkFlow/MessagesSection';
import OwnerInfoSection from 'ApplicationEntry/components/WorkFlow/OwnerInfoSection';
import PlanCodeSection from 'ApplicationEntry/components/WorkFlow/PlanCodes/PlanCodeSection';
import PolicyDetailsTab from 'ApplicationEntry/components/WorkFlow/PolicyDetailsTab';
import PremiumSection from 'ApplicationEntry/components/WorkFlow/PremiumSection';
import {createSnackbar} from 'Core/ducks/snackbar';
import PrimaryBeneficiaryDashboard from 'ApplicationEntry/components/WorkFlow/PrimaryBeneficiary/PrimaryBeneficiaryDashboard';
import ProductRiders from 'ApplicationEntry/components/WorkFlow/ProductsRiders/ProductsRiders';
import SecondaryAddresseeSection from 'ApplicationEntry/components/WorkFlow/SecondaryAddresseeSection';
import UnderwritingQuestions from 'ApplicationEntry/components/WorkFlow/UnderwritingQuestions';
import VerifyCriticalInformationDialog from 'ApplicationEntry/components/WorkFlow/VerifyCriticalInformation/VerifyCriticalInformationDialog';
import {clearApplication, issuePolicy, resetApplication} from 'ApplicationEntry/ducks/application';
import * as AWDStatusActions from 'ApplicationEntry/ducks/AWDStatus';
import {changeUserFormNumber} from 'ApplicationEntry/ducks/billingAgent';
import * as MActions from 'ApplicationEntry/ducks/messages';
import * as V from 'ApplicationEntry/ducks/verifyCriticalInformation';
import {viewWorkItemImage} from 'ApplicationEntry/ducks/workQueue';
import {InvalidApplication, matchApplicationByType, ValidApplication} from 'ApplicationEntry/models/Application';
import {ApplicationModeType} from 'ApplicationEntry/models/ApplicationModeType';
import {ApplicationType} from 'ApplicationEntry/models/ApplicationType';
import {isValidAWDStatus} from 'ApplicationEntry/models/AWDStatus/AWDStatus';
import {UpdateWork, updateWork} from 'ApplicationEntry/models/AWDStatus/UpdateWork';
import {matchAccidentByType} from 'ApplicationEntry/models/ProductsRiders/Accident/Accident';
import {matchCancerByType} from 'ApplicationEntry/models/ProductsRiders/Cancer/Cancer';
import {matchCriticalIllnessByType} from 'ApplicationEntry/models/ProductsRiders/CriticalIllness/CriticalIllness';
import {matchDisabilityByType} from 'ApplicationEntry/models/ProductsRiders/Disability/Disability';
import {ProductRiderGroups, ProductsRidersPolicyType} from 'ApplicationEntry/models/ProductsRiders/Families';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';
import {isNonEmptyString} from 'Core/models/EmptyString';
import * as O from 'fp-ts/lib/Option';
import React, {useEffect, useState, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Redirect, RouteComponentProps, useHistory, useLocation} from 'react-router-dom';
import {ReducerState} from 'rootReducer';
import Loading from 'Shared/components/Loading';
import {parseQueryString} from 'Shared/utilities/parsers';
import {toPascalCase} from 'Shared/utilities/stringFormatHelpers';
import {isLoaded as isLoadedLife70ErrorMessages} from 'ApplicationEntry/models/Life70ErrorMessages';
import './ApplicationEntry.sass';
import './WorkFlow.sass';
import {isLoading, isLoaded} from 'ApplicationEntry/models/PolicyNumber';
import {changeAsyncPolicyNumber} from 'ApplicationEntry/ducks/policyRecord';
import {Loading as AsyncLoading} from 'Core/models/Async';
import {GroupCriticalIllness} from 'ApplicationEntry/models/ProductsRiders/CriticalIllness/GroupCriticalIllness';
import {ValidGroupCaseDetails} from 'ApplicationEntry/models/GroupCaseDetails';
import {ValidPremium} from 'ApplicationEntry/models/Premium';
import {GroupCancer} from 'ApplicationEntry/models/ProductsRiders/Cancer/GroupCancer';
import {GroupAccident} from 'ApplicationEntry/models/ProductsRiders/Accident/GroupAccident';
import JStampIssuePolicyConfirmation from './JStampIssuePolicyConfirmation';
import {GroupShop} from 'ApplicationEntry/models/ProductsRiders/Shop/GroupShop';
import {GroupDisability} from 'ApplicationEntry/models/ProductsRiders/Disability/GroupDisability';
import {Messages} from 'ApplicationEntry/models/Messages';
import {matchShopByType} from 'ApplicationEntry/models/ProductsRiders/Shop/Shop';

type WorkQueueProps = {} & RouteComponentProps;

const themeColour = createMuiTheme({
  palette: {
    primary: green,
  },
});

export default function WorkDashboard(props: WorkQueueProps) {
  useBreadcrumbs('New Application', props.location.pathname);

  const dispatch = useDispatch();
  const [saveButton, setSaveButton] = React.useState('AWD Save');
  const [openVerifyDialog, setOpenVerifyDialog] = useState(false);
  const [saveToLife70, setSaveToLife70] = useState(true);
  const [showOtherSections, setShowOtherSections] = useState(false);
  const [premList] = useState<ValidPremium[]>([]);
  const [open, setOpen] = React.useState(false);
  const [aueErrMsg, setaueErrMsg] = React.useState(false);
  const [l70ErrMsg, setl70ErrMsg] = React.useState(false);
  const [policyNumberJStampL70, setPolicyNumberJStampL70] = React.useState<string[]>([]);
  const [policyNumberJStampAUE, setPolicyNumberJStampAUE] = React.useState<string[]>([]);
  let [jStampCheckbox, setjStampCheckbox] = React.useState<boolean[]>([]);

  const handleCloseVerifyDialog = () => {
    setOpenVerifyDialog(false);
    dispatch(V.clearInformation());
  };

  const enableSaveButton = () => {
    setSaveToLife70(false);
  };

  const getErroredPolicyNumberL70 = (messages: Messages) => {
    let errPolicyNumberArrl70: string[] = [];

    if (messages.key === 'ValidMessage') {
      messages.life70ErrorMessage?.Data.filter((message, idx) => {
        if (
          'life_70_audit_severity' in message['classifications'] &&
          (message['classifications']['life_70_audit_severity'].includes('Severity 2') ||
            message['classifications']['life_70_audit_severity'].includes('Severity 3'))
        ) {
          let companyCode = message['classifications']['company_code'];
          let policyNumber = message['classifications']['policy_number'];
          let prodCode = message['classifications']['product_code'];
          let fullPolicyNumber = companyCode + policyNumber + prodCode;
          errPolicyNumberArrl70.push(fullPolicyNumber);
        }
      });
    }

    return Array.from(new Set(errPolicyNumberArrl70));
  };
  const getErroredPolicyNumberAUE = (messages: Messages) => {
    let errPolicyNumberArrAUE: string[] = [];
    if (messages.key === 'ValidMessage') {
      messages.aueErrorMessage?.Data.filter((message, idx) => {
        if ('aue_code' in message['classifications']) {
          if (message['classifications']['aue_code'].includes('1000')) {
            let companyCode = message['classifications']['company_code'];
            let policyNumber = message['classifications']['policy_number'];
            let prodCode = message['classifications']['product_code'];
            let fullPolicyNumber = companyCode + policyNumber + prodCode;
            errPolicyNumberArrAUE.push(fullPolicyNumber);
          }
        }
      });
    }

    return Array.from(new Set(errPolicyNumberArrAUE));
  };

  const hasAUEKickOutOtherThan1000 = (messages: Messages) => {
    let aueKickoutOtherThan1000 = false;
    if (messages.key === 'ValidMessage') {
      messages.aueErrorMessage?.Data.some((message, idx) => {
        if ('aue_code' in message['classifications']) {
          if (message['classifications']['aue_code'].includes('1000')) {
            return false;
          } else {
            aueKickoutOtherThan1000 = true;
            return true;
          }
        }
      });
    }
    return aueKickoutOtherThan1000;
  };

  const handleShowOtherSections = () => {
    setShowOtherSections(!showOtherSections);

    const productGroups =
      application.caseDetails.productType.key === 'LoadedPolicyTypes'
        ? application.caseDetails.productType.selectedPolicyTypes
        : null;

    if (productGroups !== null) {
      if (
        productGroups.length === 1 &&
        productGroups.find(x => x.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.Aip])
      ) {
        dispatch(changeUserFormNumber('ABJNISELECT', 'NISELECT', 'ABJNISELECT', 'NISELECT', 'ABJNISELECT'));
      }
    }
  };
  const modalApplication = useSelector((state: ReducerState) => state.application);
  const {workQueue} = useSelector((state: ReducerState) => state);
  const {policyRecord} = useSelector((state: ReducerState) => state);
  const {search} = useLocation();
  const getQueryStringValue = parseQueryString(search);
  const sourceInstanceId = getQueryStringValue('sourceInstanceId');
  let policyNumber: any;
  let fullPolicyNumberRef = useRef('');

  useEffect(
    () => () => {
      dispatch(clearApplication());
    },
    [dispatch]
  );

  useEffect(() => {
    if (policyRecord.policyNumber.key === 'Loaded')
      fullPolicyNumberRef.current = `- ${(policyRecord.coCode.key === 'Empty' ? '' : policyRecord.coCode.value) +
        policyRecord.policyNumber.Data}`;
  }, [policyRecord.policyNumber]);

  const history = useHistory();

  if (modalApplication.key === 'LoadingModalApplication') {
    return <Loading />;
  } else if (modalApplication.key === 'UndeterminedModalApplication') {
    return <Redirect to={ApplicationEntryRouteConstants.WorkQueue} />;
  }

  const {application, mode} = modalApplication;

  let claims = localStorage.getItem('claims');
  let claimsObj = {};
  let userNameJStamp: string = '';
  if (claims !== null) {
    claimsObj = JSON.parse(claims!);
    userNameJStamp = claimsObj['userName'];
  }

  const handleClear = () => {
    dispatch(resetApplication());
  };

  const handleExit = () => {
    window.location.href = ApplicationEntryRouteConstants.WorkQueue;
  };

  let {billingCode, userAuthorizedJStamp} = application.caseDetails as ValidGroupCaseDetails;

  function onlyUnique(value: any, index: any, self: string | any[]) {
    return self.indexOf(value) === index;
  }
  const handleSaveToAWD = () => {
    setSaveButton('AWD Saving...');
    const work: UpdateWork = updateWork;
    work.awdKeyId = workQueue.key === 'Loaded' ? workQueue.Data.result[0].awdworkkeyid : '';
    work.comment = application.awdStatus.comments.value;
    work.businessAreaName = application.policyRecord.businessArea.value;
    work.typeName = application.awdStatus.workType.value;
    work.statusName = application.awdStatus.status.value;
    work.fieldValues[0].value = application.awdStatus.underwriter.value;

    dispatch(AWDStatusActions.updateWork(work));
  };
  const applicationType: ApplicationType = matchApplicationByType({
    Group: () => ApplicationType.Group,
    Ordinary: () => ApplicationType.Ordinary,
    NewYork: () => ApplicationType.NewYork,
    _: () => ApplicationType.Empty,
  })(application);
  let finalFilteredArr: ValidPremium[] = [];
  if (mode === ApplicationModeType.Entry && applicationType === ApplicationType.Group) {
    premList.push(application.premium as ValidPremium);
    const uniquePremList = premList?.filter(onlyUnique);
    let uniqueValidPremList = uniquePremList?.filter(arr => arr.key === 'ValidPremium');
    let uniqueValidPremListUpdated = uniqueValidPremList
      ?.map(arr => {
        return {...arr, billMode: application.premium.billMode};
      })
      .filter(uq => uq.productName.value !== undefined);

    let accidentCountArrUpdated: ValidPremium[] = [];
    let cancerCountArrUpdated: ValidPremium[] = [];
    let ciCountArrUpdated: ValidPremium[] = [];
    let shopCountArrUpdated: ValidPremium[] = [];
    const cancerCountArr = uniqueValidPremListUpdated
      ?.filter(uq => uq.productName?.value.toLowerCase() === 'cancer')
      .slice(-1);
    if (application.premium.billMode.value === '') {
      let {billingCode} = application.caseDetails as ValidGroupCaseDetails;

      if (billingCode.value === 'Monthly') {
        cancerCountArrUpdated = cancerCountArr?.map(arr => {
          return {
            ...arr,
            cwa: application.cancer.cwa,
            section125: application.cancer.section125,
            monthly: application.cancer.premium,
          };
        });
      } else {
        cancerCountArrUpdated = cancerCountArr?.map(arr => {
          return {
            ...arr,
            cwa: application.cancer.cwa,
            section125: application.cancer.section125,
            weekly: application.cancer.premium,
          };
        });
      }
    } else if (application.premium.billMode.value === 'Monthly') {
      cancerCountArrUpdated = cancerCountArr?.map(arr => {
        return {
          ...arr,
          cwa: application.cancer.cwa,
          section125: application.cancer.section125,
          monthly: application.cancer.premium,
        };
      });
    } else {
      cancerCountArrUpdated = cancerCountArr?.map(arr => {
        return {
          ...arr,
          cwa: application.cancer.cwa,
          section125: application.cancer.section125,
          weekly: application.cancer.premium,
        };
      });
    }

    const ciCountArr = uniqueValidPremListUpdated
      ?.filter(uq => uq.productName?.value.toLowerCase() === 'critical illness')
      .slice(-1);

    if (application.premium.billMode.value === '') {
      let {billingCode} = application.caseDetails as ValidGroupCaseDetails;

      if (billingCode.value === 'Monthly') {
        ciCountArrUpdated = ciCountArr?.map(arr => {
          return {
            ...arr,
            cwa: application.criticalIllness.cwa,
            section125: application.criticalIllness.section125,
            monthly: application.criticalIllness.premium,
          };
        });
      } else {
        ciCountArrUpdated = ciCountArr?.map(arr => {
          return {
            ...arr,
            cwa: application.criticalIllness.cwa,
            section125: application.criticalIllness.section125,
            weekly: application.criticalIllness.premium,
          };
        });
      }
    } else if (application.premium.billMode.value === 'Monthly') {
      ciCountArrUpdated = ciCountArr?.map(arr => {
        return {
          ...arr,
          cwa: application.criticalIllness.cwa,
          section125: application.criticalIllness.section125,
          monthly: application.criticalIllness.premium,
        };
      });
    } else {
      ciCountArrUpdated = ciCountArr?.map(arr => {
        return {
          ...arr,
          cwa: application.criticalIllness.cwa,
          section125: application.criticalIllness.section125,
          weekly: application.criticalIllness.premium,
        };
      });
    }

    const accidentCountArr = uniqueValidPremListUpdated
      ?.filter(uq => uq.productName?.value.toLowerCase() === 'accident')
      .slice(-1);
    if (application.premium.billMode.value === '') {
      let {billingCode} = application.caseDetails as ValidGroupCaseDetails;

      if (billingCode.value === 'Monthly') {
        accidentCountArrUpdated = accidentCountArr?.map(arr => {
          return {
            ...arr,
            cwa: application.accident.cwa,
            section125: application.accident.section125,
            monthly: application.accident.premium,
          };
        });
      } else {
        accidentCountArrUpdated = accidentCountArr?.map(arr => {
          return {
            ...arr,
            cwa: application.accident.cwa,
            section125: application.accident.section125,
            weekly: application.accident.premium,
          };
        });
      }
    } else if (application.premium.billMode.value === 'Monthly') {
      accidentCountArrUpdated = accidentCountArr?.map(arr => {
        return {
          ...arr,
          cwa: application.accident.cwa,
          section125: application.accident.section125,
          monthly: application.accident.premium,
        };
      });
    } else {
      accidentCountArrUpdated = accidentCountArr?.map(arr => {
        return {
          ...arr,
          cwa: application.accident.cwa,
          section125: application.accident.section125,
          weekly: application.accident.premium,
        };
      });
    }

    const shopCountArr = uniqueValidPremListUpdated
      ?.filter(uq => uq.productName?.value.toLowerCase() === 'hospital indemnity (shop)')
      .slice(-1);
    if (application.premium.billMode.value === '') {
      let {billingCode} = application.caseDetails as ValidGroupCaseDetails;

      if (billingCode.value === 'Monthly') {
        shopCountArrUpdated = shopCountArr?.map(arr => {
          return {
            ...arr,
            cwa: application?.shop.cwa,
            section125: application?.shop.section125,
            monthly: application?.shop.premium,
          };
        });
      } else {
        shopCountArrUpdated = shopCountArr?.map(arr => {
          return {
            ...arr,
            cwa: application?.shop.cwa,
            section125: application?.shop.section125,
            weekly: application?.shop.premium,
          };
        });
      }
    } else if (application.premium.billMode.value === 'Monthly') {
      shopCountArrUpdated = shopCountArr?.map(arr => {
        return {
          ...arr,
          cwa: application.shop.cwa,
          section125: application.shop.section125,
          monthly: application.shop.premium,
        };
      });
    } else {
      shopCountArrUpdated = shopCountArr?.map(arr => {
        return {
          ...arr,
          cwa: application.shop.cwa,
          section125: application.shop.section125,
          weekly: application.shop.premium,
        };
      });
    }

    let finalresArr: ValidPremium[] = [
      ...cancerCountArrUpdated,
      ...ciCountArrUpdated,
      ...accidentCountArrUpdated,
      ...shopCountArrUpdated,
    ];

    finalFilteredArr = finalresArr?.filter(function(obj) {
      return (
        application.caseDetails.productType.key === 'LoadedPolicyTypes' &&
        application.caseDetails.productType.selectedPolicyTypes.some(function(obj2) {
          return obj?.productName?.value.toLowerCase() === obj2.name!.toLowerCase();
        })
      );
    });
  }

  const {
    caseDetails,
    applicantDemographics,
    ownerInfo,
    secondaryAddressee,
    dependents,
    premium,
    billingAgent,
    awdStatus,
  } = application;

  const applicationName = matchApplicationByType({
    Group: () => 'Group',
    Ordinary: () => 'Ordinary',
    NewYork: () => 'New York',
    _: () => '',
  })(application);

  const handleIssuePolicy = () => {
    const policyNumber =
      application.caseDetails.policyNumber.key === 'UserAssignedPolicyNumber'
        ? application.caseDetails.policyNumber.value
        : null;

    if (applicationType === ApplicationType.Group && mode === ApplicationModeType.Entry) {
      // If single/all policies have jstamp enabled and all has no sev3/sev2 and AUE errors.
      const groupAccident = application.accident as GroupAccident;
      const groupCancer = application.cancer as GroupCancer;
      const groupCI = application.criticalIllness as GroupCriticalIllness;
      const groupDisability = application.disability as GroupDisability;
      const groupShop = application.shop as GroupShop;
      if (
        (getJstampValue(application) || jStampCheckbox.some((value, idx) => value === true)) &&
        application.messages.life70ErrorMessage.key === 'Loaded' &&
        !application.messages.life70ErrorMessage.Data.some((message, idx) =>
          message['classifications']['life_70_audit_severity']?.includes('Severity 3')
        ) &&
        application.messages.life70ErrorMessage.key === 'Loaded' &&
        !application.messages.life70ErrorMessage.Data.some((message, idx) =>
          message['classifications']['life_70_audit_severity']?.includes('Severity 2')
        ) &&
        !hasAUEKickOutOtherThan1000(application.messages)
      ) {
        let errPolicyNumbersListL70 = getErroredPolicyNumberL70(application.messages);
        let errPolicyNumberListAUE = getErroredPolicyNumberAUE(application.messages);

        if (workQueue.key === 'Loaded') {
          if (workQueue.Data.result.length > 0) {
            workQueue.Data.result.forEach((workItem, idx) => {
              let policyNumberCoCode = policyRecord.coCode.key === 'Empty' ? '' : policyRecord.coCode.value;
              if (groupAccident?.jStamp) {
                if (workItem.policyNumber?.endsWith('4')) {
                  dispatch(issuePolicy(policyNumberCoCode + workItem.policyNumber!));
                  sessionStorage.setItem('IssuedPolicy' + idx, policyNumberCoCode + workItem.policyNumber!);
                  sessionStorage.setItem('mode', 'Entry');
                }
              }
              if (groupCancer?.jStamp) {
                if (workItem.policyNumber?.endsWith('2')) {
                  dispatch(issuePolicy(policyNumberCoCode + workItem.policyNumber!));
                  sessionStorage.setItem('IssuedPolicy' + idx, policyNumberCoCode + workItem.policyNumber!);
                  sessionStorage.setItem('mode', 'Entry');
                }
              }
              if (groupCI?.jStamp) {
                if (workItem.policyNumber?.endsWith('7')) {
                  dispatch(issuePolicy(policyNumberCoCode + workItem.policyNumber!));
                  sessionStorage.setItem('IssuedPolicy' + idx, policyNumberCoCode + workItem.policyNumber!);
                  sessionStorage.setItem('mode', 'Entry');
                }
              }
              if (groupDisability?.jStamp) {
                if (workItem.policyNumber?.endsWith('1')) {
                  dispatch(issuePolicy(policyNumberCoCode + workItem.policyNumber!));
                  sessionStorage.setItem('IssuedPolicy' + idx, policyNumberCoCode + workItem.policyNumber!);
                  sessionStorage.setItem('mode', 'Entry');
                }
              }
              if (groupShop?.jstamp) {
                if (workItem.policyNumber?.endsWith('5')) {
                  dispatch(issuePolicy(policyNumberCoCode + workItem.policyNumber!));
                  sessionStorage.setItem('IssuedPolicy' + idx, policyNumberCoCode + workItem.policyNumber!);
                  sessionStorage.setItem('mode', 'Entry');
                }
              }
            });
          }
        }
      }
      // if all/single jstamped checked policy is having sev2/sev3 or AUE error
      // not to issue the policy unless all jstamp checked policy has no sev3/sev2 and AUE error.
      else if (getJstampValue(application) || jStampCheckbox.some((value, idx) => value === true)) {
        if (
          (application.messages.life70ErrorMessage.key === 'Loaded' &&
            application.messages.life70ErrorMessage.Data.some((message, idx) =>
              message['classifications']['life_70_audit_severity']?.includes('Severity 3')
            )) ||
          (application.messages.life70ErrorMessage.key === 'Loaded' &&
            application.messages.life70ErrorMessage.Data.some((message, idx) =>
              message['classifications']['life_70_audit_severity']?.includes('Severity 2')
            )) ||
          (application.messages.aueErrorMessage.key === 'Loaded' &&
            !application.messages.aueErrorMessage.Data.some((message, idx) =>
              message['message'].includes('Code: 1000')
            )) ||
          hasAUEKickOutOtherThan1000(application.messages)
        ) {
          let errPolicyNumbersListL70 = getErroredPolicyNumberL70(application.messages);
          let errPolicyNumberListAUE = getErroredPolicyNumberAUE(application.messages);
          if (workQueue.key === 'Loaded') {
            if (workQueue.Data.result.length > 0) {
              workQueue.Data.result.forEach((workItem, idx) => {
                let policyNumberCoCode = policyRecord.coCode.key === 'Empty' ? '' : policyRecord.coCode.value;
                if (groupAccident?.jStamp) {
                  if (workItem.policyNumber?.endsWith('4')) {
                    let groupAccidentErrors = false;
                    if (
                      errPolicyNumbersListL70.some(
                        (l70errPolicy, idx) => l70errPolicy === policyNumberCoCode + workItem.policyNumber!
                      )
                    ) {
                      groupAccidentErrors = true;
                      setl70ErrMsg(true);
                      setOpen(true);
                      setPolicyNumberJStampL70(errPolicyNumbersListL70);
                    }
                    if (
                      errPolicyNumberListAUE.some(
                        (aueErrPolicy, idx) => aueErrPolicy === policyNumberCoCode + workItem.policyNumber!
                      )
                    ) {
                      groupAccidentErrors = true;
                      setaueErrMsg(true);
                      setOpen(true);
                      setPolicyNumberJStampAUE(errPolicyNumberListAUE);
                    }
                    if (
                      groupAccidentErrors === false &&
                      jStampCheckbox.some((checkedJstamp, idx) => checkedJstamp === false)
                    ) {
                      dispatch(issuePolicy(policyNumberCoCode + workItem.policyNumber!));
                      sessionStorage.setItem('IssuedPolicy' + idx, policyNumberCoCode + workItem.policyNumber!);
                      sessionStorage.setItem('mode', 'Entry');
                    }
                  }
                }
                if (groupCancer?.jStamp) {
                  if (workItem.policyNumber?.endsWith('2')) {
                    let groupCancerErrors = false;
                    if (
                      errPolicyNumbersListL70.some(
                        (l70errPolicy, idx) => l70errPolicy === policyNumberCoCode + workItem.policyNumber!
                      )
                    ) {
                      groupCancerErrors = true;
                      setl70ErrMsg(true);
                      setOpen(true);
                      setPolicyNumberJStampL70(errPolicyNumbersListL70);
                    }
                    if (
                      errPolicyNumberListAUE.some(
                        (aueErrPolicy, idx) => aueErrPolicy === policyNumberCoCode + workItem.policyNumber!
                      )
                    ) {
                      groupCancerErrors = true;
                      setaueErrMsg(true);
                      setOpen(true);
                      setPolicyNumberJStampAUE(errPolicyNumberListAUE);
                    }
                    if (
                      groupCancerErrors === false &&
                      jStampCheckbox.some((checkedJstamp, idx) => checkedJstamp === false)
                    ) {
                      dispatch(issuePolicy(policyNumberCoCode + workItem.policyNumber!));
                      sessionStorage.setItem('IssuedPolicy' + idx, policyNumberCoCode + workItem.policyNumber!);
                      sessionStorage.setItem('mode', 'Entry');
                    }
                  }
                }
                if (groupCI?.jStamp) {
                  if (workItem.policyNumber?.endsWith('7')) {
                    let groupCIErrors = false;
                    if (
                      errPolicyNumbersListL70.some(
                        (l70errPolicy, idx) => l70errPolicy === policyNumberCoCode + workItem.policyNumber!
                      )
                    ) {
                      groupCIErrors = true;
                      setl70ErrMsg(true);
                      setOpen(true);
                      setPolicyNumberJStampL70(errPolicyNumbersListL70);
                    }
                    if (
                      errPolicyNumberListAUE.some(
                        (aueErrPolicy, idx) => aueErrPolicy === policyNumberCoCode + workItem.policyNumber!
                      )
                    ) {
                      groupCIErrors = true;
                      setaueErrMsg(true);
                      setOpen(true);
                      setPolicyNumberJStampAUE(errPolicyNumberListAUE);
                    }
                    if (
                      groupCIErrors === false &&
                      jStampCheckbox.some((checkedJstamp, idx) => checkedJstamp === false)
                    ) {
                      dispatch(issuePolicy(policyNumberCoCode + workItem.policyNumber!));
                      sessionStorage.setItem('IssuedPolicy' + idx, policyNumberCoCode + workItem.policyNumber!);
                      sessionStorage.setItem('mode', 'Entry');
                    }
                  }
                }
                if (groupDisability?.jStamp) {
                  if (workItem.policyNumber?.endsWith('1')) {
                    let groupDisabilityErrors = false;
                    if (
                      errPolicyNumbersListL70.some(
                        (l70errPolicy, idx) => l70errPolicy === policyNumberCoCode + workItem.policyNumber!
                      )
                    ) {
                      groupDisabilityErrors = true;
                      setl70ErrMsg(true);
                      setOpen(true);
                      setPolicyNumberJStampL70(errPolicyNumbersListL70);
                    }
                    if (
                      errPolicyNumberListAUE.some(
                        (aueErrPolicy, idx) => aueErrPolicy === policyNumberCoCode + workItem.policyNumber!
                      )
                    ) {
                      groupDisabilityErrors = true;
                      setaueErrMsg(true);
                      setOpen(true);
                      setPolicyNumberJStampAUE(errPolicyNumberListAUE);
                    }
                    if (
                      groupDisabilityErrors === false &&
                      jStampCheckbox.some((checkedJstamp, idx) => checkedJstamp === false)
                    ) {
                      dispatch(issuePolicy(policyNumberCoCode + workItem.policyNumber!));
                      sessionStorage.setItem('IssuedPolicy' + idx, policyNumberCoCode + workItem.policyNumber!);
                      sessionStorage.setItem('mode', 'Entry');
                    }
                  }
                }
                if (groupShop?.jstamp) {
                  if (workItem.policyNumber?.endsWith('5')) {
                    let groupShopErrors = false;
                    if (
                      errPolicyNumbersListL70.some(
                        (l70errPolicy, idx) => l70errPolicy === policyNumberCoCode + workItem.policyNumber!
                      )
                    ) {
                      groupShopErrors = true;
                      setl70ErrMsg(true);
                      setOpen(true);
                      setPolicyNumberJStampL70(errPolicyNumbersListL70);
                    }
                    if (
                      errPolicyNumberListAUE.some(
                        (aueErrPolicy, idx) => aueErrPolicy === policyNumberCoCode + workItem.policyNumber!
                      )
                    ) {
                      groupShopErrors = true;
                      setaueErrMsg(true);
                      setOpen(true);
                      setPolicyNumberJStampAUE(errPolicyNumberListAUE);
                    }
                    if (
                      groupShopErrors === false &&
                      jStampCheckbox.some((checkedJstamp, idx) => checkedJstamp === false)
                    ) {
                      dispatch(issuePolicy(policyNumberCoCode + workItem.policyNumber!));
                      sessionStorage.setItem('IssuedPolicy' + idx, policyNumberCoCode + workItem.policyNumber!);
                      sessionStorage.setItem('mode', 'Entry');
                    }
                  }
                }
              });
            }
          }
        }
      } else {
        if (policyNumber !== null) {
          dispatch(issuePolicy(policyNumber));
        }
      }
    } else {
      if (policyNumber !== null) {
        dispatch(issuePolicy(policyNumber));
        sessionStorage.setItem('IssuedPolicy', policyNumber);
        sessionStorage.setItem('mode', 'Quality');
      }
    }
  };

  const getJstampValue = (application: ValidApplication | InvalidApplication) => {
    let jStampValue = false;
    let JstampValueCheckedArr: boolean[] = [];
    if (application.caseDetails.productType.key === 'LoadedPolicyTypes') {
      const selectedPolicyList = application.caseDetails.productType.selectedPolicyTypes;

      selectedPolicyList.forEach(selectedPolicy => {
        switch (selectedPolicy.productGroup?.toLocaleUpperCase()) {
          case ProductRiderGroups[ProductsRidersPolicyType.Cancer]:
            jStampValue = matchCancerByType({
              Group: groupApp => groupApp.jStamp,
              _: () => false,
            })(application.cancer);
            JstampValueCheckedArr.push(jStampValue);
            break;
          case ProductRiderGroups[ProductsRidersPolicyType.Accident]:
            jStampValue = matchAccidentByType({
              Group: groupApp => groupApp.jStamp,
              _: () => false,
            })(application.accident);
            JstampValueCheckedArr.push(jStampValue);
            break;
          case ProductRiderGroups[ProductsRidersPolicyType.CriticalIllness]:
            jStampValue = matchCriticalIllnessByType({
              Group: groupApp => groupApp.jStamp,
              _: () => false,
            })(application.criticalIllness);
            JstampValueCheckedArr.push(jStampValue);
            break;
          case ProductRiderGroups[ProductsRidersPolicyType.Disability]:
            jStampValue = matchDisabilityByType({
              Group: groupApp => groupApp.jStamp,
              _: () => false,
            })(application.disability);
            JstampValueCheckedArr.push(jStampValue);
            break;
          case ProductRiderGroups[ProductsRidersPolicyType.Shop]:
            jStampValue = matchShopByType({
              Group: groupApp => groupApp.jstamp,
              _: () => false,
            })(application.shop);
            JstampValueCheckedArr.push(jStampValue);
            break;
        }
      });
    }
    jStampCheckbox = JstampValueCheckedArr;
    return jStampValue;
  };

  const handleClose = () => {
    setOpen(false);
    setl70ErrMsg(false);
    setaueErrMsg(false);
  };

  const isQuality = mode === ApplicationModeType.Quality;
  const isResave = () =>
    isLoadedLife70ErrorMessages(application.messages.life70ErrorMessage) &&
    application.messages.life70ErrorMessage.Data.some(
      element =>
        element['classifications'] &&
        'life_70_code' in element['classifications'] &&
        element['classifications']['life_70_code'] === 'S'
    );

  const disableL70Save = () => {
    let disableSaveBtn = true;
    if (isQuality && !application.planCodes.replaceProduct) {
      disableSaveBtn = false;
    } else {
      if (application.caseDetails.productType.key === 'LoadedPolicyTypes') {
        const selectedPolicyList = application.caseDetails.productType.selectedPolicyTypes;
        let isEmptyPlanType = false;

        selectedPolicyList.forEach(selectedPolicy => {
          switch (selectedPolicy.productGroup?.toLocaleUpperCase()) {
            case ProductRiderGroups[ProductsRidersPolicyType.Accident]:
              isEmptyPlanType = matchAccidentByType({
                Ordinary: ordinaryApp => isNonEmptyString(ordinaryApp.planType),
                Group: groupApp => isNonEmptyString(groupApp.planType),
                _: () => true,
              })(application.accident);
              break;
            case ProductRiderGroups[ProductsRidersPolicyType.Cancer]:
              isEmptyPlanType = matchCancerByType({
                Ordinary: ordinaryApp => isNonEmptyString(ordinaryApp.planType),
                Group: groupApp => isNonEmptyString(groupApp.planType),
                _: () => true,
              })(application.cancer);
              break;
            case ProductRiderGroups[ProductsRidersPolicyType.CriticalIllness]:
              isEmptyPlanType = matchCriticalIllnessByType({
                Ordinary: ordinaryApp => isNonEmptyString(ordinaryApp.planType),
                Group: groupApp => isNonEmptyString(groupApp.planType),
                _: () => true,
              })(application.criticalIllness);
              break;
            case ProductRiderGroups[ProductsRidersPolicyType.Disability]:
              isEmptyPlanType = matchDisabilityByType({
                Ordinary: ordinaryApp => isNonEmptyString(ordinaryApp.riderType),
                Group: groupApp => isNonEmptyString(groupApp.type),
                _: () => true,
              })(application.disability);
              break;
            case ProductRiderGroups[ProductsRidersPolicyType.UniversalLife]:
              isEmptyPlanType = isNonEmptyString(application.universalLife.type);
              break;
            case ProductRiderGroups[ProductsRidersPolicyType.Iwl]:
              isEmptyPlanType = isNonEmptyString(application.iwl.plan);
              break;
            case ProductRiderGroups[ProductsRidersPolicyType.Gwl]:
              isEmptyPlanType = isNonEmptyString(application.iwl.type);
              break;
            case ProductRiderGroups[ProductsRidersPolicyType.Icrtn]:
              isEmptyPlanType = isNonEmptyString(application.icrtn.planType);
              break;
            case ProductRiderGroups[ProductsRidersPolicyType.GLTerm]:
              isEmptyPlanType = isNonEmptyString(application.glterm.type);
              break;
            case ProductRiderGroups[ProductsRidersPolicyType.Aip]:
              isEmptyPlanType = isNonEmptyString(application.aip.planType);
              break;
            case ProductRiderGroups[ProductsRidersPolicyType.Shop]:
              isEmptyPlanType = isNonEmptyString(application.shop.planType);
              break;
          }
        });

        let billingMode = application.billingAgent.billingMode || billingCode;
        if (application.billingAgent.billingMode.value === '') {
          billingMode = billingCode;
        }

        if (isNonEmptyString(billingMode) && billingMode.value !== 'Unknown' && isEmptyPlanType) {
          disableSaveBtn = false;
        }
      }
    }

    return disableSaveBtn;
  };

  if (isLoaded(application.policyRecord.policyNumber)) {
    policyNumber =
      application.policyRecord.policyNumber.Data !== ''
        ? `- ${(application.policyRecord.coCode.key === 'Empty' ? '' : application.policyRecord.coCode.value) +
            application.policyRecord.policyNumber.Data}`
        : '';
  } else if (isLoading(application.policyRecord.policyNumber)) {
    policyNumber = <CircularProgress className="case-details-section__loading-policy-number-icon" />;
  } else {
    policyNumber = fullPolicyNumberRef.current;
  }

  return (
    <div className="workflow">
      <Container className="workflow__stepper " maxWidth={false}>
        <div className="workflow__main-header">
          {mode.toUpperCase() === 'QUALITY' ? (
            <Typography variant="subtitle1" className="workflow__head">
              AppEntry {applicationName} Product - {toPascalCase(mode)}
            </Typography>
          ) : (
            <Typography variant="subtitle1" className="workflow__head">
              AppEntry {applicationName} Products - {toPascalCase(mode)}
            </Typography>
          )}

          <Button
            variant="contained"
            color="primary"
            className="workflow__get-work-btn"
            onClick={() => {
              if (O.isSome(sourceInstanceId)) {
                dispatch(viewWorkItemImage(sourceInstanceId.value));
              }
            }}
          >
            GET WORK IMAGE
          </Button>
        </div>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-label="Expand"
            aria-controls="additional-actions1-content"
            id="additional-actions1-header"
          >
            Policy Details {policyNumber}
          </AccordionSummary>
          <AccordionDetails>
            <PolicyDetailsTab application={application} />
          </AccordionDetails>
        </Accordion>
        {!isQuality ? (
          <CaseDetailsSection
            caseDetails={caseDetails}
            showOtherSectionsHandler={handleShowOtherSections}
            showOtherSections={showOtherSections}
            modalApplication={modalApplication}
            userNameJStamp={userNameJStamp}
          />
        ) : null}
        {isQuality || showOtherSections ? (
          <div className={isQuality || showOtherSections! ? 'workflow__show' : 'workflow__hide'}>
            <ApplicantDemographicsSection application={application} isQuality={isQuality} />
            <OwnerInfoSection ownerInfo={ownerInfo} applicantDemographics={applicantDemographics} />
            <DependentsDashboard dependents={dependents} application={application} isQuality={isQuality} />
            {!isQuality && <ProductRiders application={application} mode={mode} />}
            <SecondaryAddresseeSection secondaryAddressee={secondaryAddressee} />
            {caseDetails.productType.key === 'LoadedPolicyTypes' &&
              caseDetails.productType.selectedPolicyTypes[0]?.productGroup?.toLocaleLowerCase()! !==
                ProductRiderGroups[ProductsRidersPolicyType.Aip].toLocaleLowerCase() && (
                <PrimaryBeneficiaryDashboard modalApplication={modalApplication} />
              )}
            <ContingentBeneficiaryDashboard modalApplication={modalApplication} />
            {isQuality && (
              <>
                {caseDetails.productType.key === 'LoadedPolicyTypes' &&
                  caseDetails.productType.selectedPolicyTypes[0]?.productGroup?.toLocaleLowerCase()! !==
                    ProductRiderGroups[ProductsRidersPolicyType.Aip].toLocaleLowerCase() &&
                  caseDetails.productType.selectedPolicyTypes[0]?.productGroup?.toLocaleLowerCase()! !==
                    ProductRiderGroups[ProductsRidersPolicyType.Accident].toLocaleLowerCase()}
                <AdditionalPropertiesSection application={application} />
                <PlanCodeSection application={application} mode={mode} />
                <PremiumSection billingAgent={billingAgent} premium={premium} isQuality={isQuality} />
              </>
            )}
            {!isQuality && applicationType === ApplicationType.Group && (
              <>
                {(caseDetails.productType.key === 'LoadedPolicyTypes' &&
                  caseDetails.productType.selectedPolicyTypes[0]?.productGroup?.toLocaleLowerCase() ===
                    ProductRiderGroups[ProductsRidersPolicyType.Accident].toLocaleLowerCase()) ||
                (caseDetails.productType.key === 'LoadedPolicyTypes' &&
                  caseDetails.productType.selectedPolicyTypes[0]?.productGroup?.toLocaleLowerCase() ===
                    ProductRiderGroups[ProductsRidersPolicyType.CriticalIllness].toLocaleLowerCase()) ||
                (caseDetails.productType.key === 'LoadedPolicyTypes' &&
                  caseDetails.productType.selectedPolicyTypes[0]?.productGroup?.toLocaleLowerCase() ===
                    ProductRiderGroups[ProductsRidersPolicyType.Cancer].toLocaleLowerCase()) ||
                (caseDetails.productType.key === 'LoadedPolicyTypes' &&
                  caseDetails.productType.selectedPolicyTypes[0]?.productGroup?.toLocaleLowerCase() ===
                    ProductRiderGroups[ProductsRidersPolicyType.Shop].toLocaleLowerCase())
                  ? finalFilteredArr?.map((item, idx) => {
                      return (
                        <PremiumSection
                          billingAgent={billingAgent}
                          premium={item}
                          criticalIllness={application.criticalIllness as GroupCriticalIllness}
                          caseDetails={application.caseDetails as ValidGroupCaseDetails}
                          productGroupName={item.productName.value}
                          isQuality={isQuality}
                        />
                      );
                    })
                  : ''}
              </>
            )}

            <BillingAgentSection modalApplication={modalApplication} />
            {!isQuality && (
              <>
                <UnderwritingQuestions
                  uwQuestions={application.uwQuestions}
                  formNumber={billingAgent.formNumber}
                  applicationType={applicationType}
                />
                <HippaTrustees hippaTrustees={application.hippaTrustees} applicationType={applicationType} />
              </>
            )}

            <MessagesSection modalApplication={modalApplication} isQuality={isQuality} />
            <AWDStatusDashboard
              awdStatus={awdStatus}
              policyRecord={application.policyRecord}
              workQueueItemList={workQueue.key === 'Loaded' ? workQueue.Data.result : undefined}
              isQuality={isQuality}
            />
            <div className="workflow__buttons-container">
              <div className="button-wrapper">
                {!isQuality && (
                  <Button
                    variant="contained"
                    color="secondary"
                    className="workflow__buttons workflow__buttons-secondary-action"
                    onClick={() => {
                      setOpenVerifyDialog(true);
                    }}
                  >
                    Verify
                  </Button>
                )}
                <ThemeProvider theme={themeColour}>
                  <Button
                    variant="contained"
                    color="primary"
                    className="workflow__buttons workflow__buttons-primary-action"
                    onClick={() => {
                      let havingBeneficiaryPercentError = false;
                      let havingBeneficiaryPercentErrorContingent = false;
                      if (isQuality || isResave()) {
                        let beneficiaryPercent = 0;
                        if (
                          modalApplication?.application?.primaryBeneficiaryList?.primaryBeneficiaryList?.count() > 0
                        ) {
                          beneficiaryPercent = modalApplication?.application?.primaryBeneficiaryList?.primaryBeneficiaryList?.reduce(
                            (n, {percent}) => n + percent,
                            0
                          );
                          if (beneficiaryPercent !== 100) {
                            havingBeneficiaryPercentError = true;
                          }
                        }

                        let beneficiaryPercentContingent = 0;
                        if (
                          modalApplication?.application?.contingentBeneficiaryList?.contingentBeneficiaryList?.count() >
                          0
                        ) {
                          beneficiaryPercentContingent = modalApplication?.application?.contingentBeneficiaryList?.contingentBeneficiaryList?.reduce(
                            (n, {percent}) => n + percent,
                            0
                          );
                          if (beneficiaryPercentContingent !== 100) {
                            havingBeneficiaryPercentErrorContingent = true;
                          }
                        }

                        if (havingBeneficiaryPercentError && havingBeneficiaryPercentErrorContingent) {
                          dispatch(
                            createSnackbar(
                              'Please correct beneficiary percent of Primary Beneficiary and Contingent Beneficiary is not equal to 100%.'
                            )
                          );
                        } else if (havingBeneficiaryPercentError) {
                          dispatch(
                            createSnackbar(
                              'Please correct beneficiary percent of Primary Beneficiary is not equal to 100%.'
                            )
                          );
                        } else if (havingBeneficiaryPercentErrorContingent) {
                          dispatch(
                            createSnackbar(
                              'Please correct beneficiary percent of Contingent Beneficiary is not equal to 100%.'
                            )
                          );
                        }

                        if (
                          havingBeneficiaryPercentError === false &&
                          havingBeneficiaryPercentErrorContingent === false
                        ) {
                          dispatch(
                            MActions.updateApplication(
                              modalApplication,
                              workQueue.key === 'Loaded' ? workQueue.Data.result[0].awdworkkeyid : ''
                            )
                          );
                        }
                      } else {
                        dispatch(changeAsyncPolicyNumber(new AsyncLoading()));
                        dispatch(
                          MActions.saveApplication(
                            modalApplication,
                            workQueue.key === 'Loaded' ? workQueue.Data.result : [],
                            false
                          )
                        );
                      }
                    }}
                    disabled={!isQuality ? saveToLife70 : false}
                  >
                    Save
                  </Button>
                </ThemeProvider>
                <ThemeProvider theme={themeColour}>
                  <Button
                    variant="contained"
                    color="primary"
                    className="workflow__buttons workflow__buttons-primary-action"
                    onClick={() => {
                      dispatch(
                        MActions.saveApplication(
                          modalApplication,
                          workQueue.key === 'Loaded' ? workQueue.Data.result : [],
                          true
                        )
                      );
                    }}
                    disabled={!isValidAWDStatus(application.awdStatus)}
                  >
                    {saveButton}
                  </Button>
                </ThemeProvider>
                {isQuality ? (
                  <ThemeProvider theme={themeColour}>
                    <Button
                      variant="contained"
                      color="primary"
                      className="workflow__buttons workflow__buttons-primary-action"
                      onClick={handleIssuePolicy}
                      disabled={application.caseDetails.policyNumber.key !== 'UserAssignedPolicyNumber'}
                    >
                      Issue Policy
                    </Button>
                  </ThemeProvider>
                ) : null}
                {!isQuality && (getJstampValue(application) || jStampCheckbox.some((value, idx) => value === true)) ? (
                  <ThemeProvider theme={themeColour}>
                    <Button
                      variant="contained"
                      color="primary"
                      className="workflow__buttons workflow__buttons-primary-action"
                      onClick={handleIssuePolicy}
                      disabled={!(getJstampValue(application) || jStampCheckbox.some((value, idx) => value === true))}
                    >
                      Issue Policy
                    </Button>
                  </ThemeProvider>
                ) : null}
                <Button variant="contained" color="inherit" onClick={handleClear} className="workflow__buttons">
                  Clear
                </Button>
                <Button variant="contained" color="inherit" onClick={handleExit} className="workflow__buttons">
                  Exit
                </Button>
              </div>
            </div>
          </div>
        ) : null}
      </Container>
      <VerifyCriticalInformationDialog
        application={application}
        open={openVerifyDialog}
        onClose={handleCloseVerifyDialog}
        onSaveToLife70={enableSaveButton}
      />
      <JStampIssuePolicyConfirmation
        policyNumberL70={policyNumberJStampL70}
        policyNumberAUE={policyNumberJStampAUE}
        handleClose={handleClose}
        open={open}
        aueErrMsg={aueErrMsg}
        l70ErrMsg={l70ErrMsg}
      />
    </div>
  );
}
